import { Navigate, Routes, Route, useLocation } from 'react-router-dom';
import PrivateRoute from '../components/common/PrivateRoute.js';
import Layout from '../components/Products/FeedbackHero/layout/Layout.jsx';
import FeedbackHero from '../components/Products/FeedbackHero/FeedbackHero.jsx';
import FeedbackHeroSettings from '../components/Products/FeedbackHero/FeedbackHeroSettings.jsx';
import FeedbackPeriodComparison from '../components/Products/FeedbackHero/FeedbackPeriodComparison.jsx';
import Questions from '../components/Products/FeedbackForm/pages/Questions.jsx';
import QuestionEditor from '../components/Products/FeedbackForm/pages/QuestionEditor.jsx';
import Sessions from '../components/Products/FeedbackForm/pages/Sessions.jsx';
import SessionDetail from '../components/Products/FeedbackForm/pages/SessionDetail.jsx';

const GoogleSettingsRedirect = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  params.set('integracao', 'google');
  return <Navigate to={`/feedback-hero/configuracoes?${params.toString()}`} replace />;
};

const FeedbackHeroRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute product="feedback_hero">
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<FeedbackHero />} />
        <Route path="comparativo" element={<FeedbackPeriodComparison />} />
        <Route path="google" element={<GoogleSettingsRedirect />} />
        <Route path="google/configurar" element={<GoogleSettingsRedirect />} />
        <Route path="ifood" element={<Navigate to="/feedback-hero" replace />} />
        <Route path="configuracoes" element={<FeedbackHeroSettings />} />
        <Route path="form" element={<Questions />} />
        <Route path="form/perguntas/:id" element={<QuestionEditor />} />
        <Route path="respostas" element={<Sessions />} />
        <Route path="respostas/:id" element={<SessionDetail />} />
      </Route>
    </Routes>
  );
};

export default FeedbackHeroRoutes;
